// The lookalike block's sentences (ART-295). Their own module, like `targetingFormat`, so the block and its tests
// read them without tripping `react-refresh/only-export-components`.

/** "IS" → "Iceland", in the reader's language; an unknown code reads as itself. */
export function countryName(code: string): string {
  try {
    return new Intl.DisplayNames(undefined, { type: "region" }).of(code) ?? code;
  } catch {
    return code;
  }
}

function joinOr(names: string[]): string {
  if (names.length <= 1) return names[0] ?? "";
  if (names.length === 2) return `${names[0]} or ${names[1]}`;
  return `${names.slice(0, -1).join(", ")}, or ${names[names.length - 1]}`;
}

/** The status line under the size control — where the lookalike for these settings is. The ad can always be
 *  pushed while one builds; the line says so rather than leaving the band to wonder. */
export function lookalikeStatusLine(state: string | null | undefined, tooSmallCountryNames: string[] = []): string | null {
  switch (state) {
    case "new":
      return "We'll build this lookalike when you push live — usually ready in a few hours. You can still launch.";
    case "building":
      return "Building… usually ready in a few hours. You can still launch.";
    case "ready":
      return "Ready";
    case "too-small":
      return tooSmallCountryNames.length
        ? `Not enough fans in ${joinOr(tooSmallCountryNames)} yet — try a different country or a bigger mirror.`
        : "Not enough fans in these countries yet — try a different country or a bigger mirror.";
    default:
      return null;
  }
}

/** Why the lookalike block cannot offer anything — the ART-295 §6 mapping. Each is a different fix. */
export function lookalikeUnavailableLine(state: string): string {
  switch (state) {
    case "not-connected":
      return "Connect Meta to build a lookalike audience.";
    case "ads-permission-missing":
      return "Reconnect Meta and allow ad access.";
    case "no-ad-account":
      return "Pick the ad account for this band.";
    case "custom-audience-terms":
      return "Meta needs you to accept its Custom Audience terms once.";
    default:
      return "Meta didn't answer just now. Try again in a moment.";
  }
}
